import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Observable} from 'rxjs';
import {filterByTerm, lodash} from '../../utils';

@Component({
    selector: 'app-local-filter',
    templateUrl: './local-filter.component.html',
    styleUrls: ['./local-filter.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocalFilterComponent {
  private filterTerm: string;

  get term(): string {
    return this.filterTerm;
  }

  @Input() set term(value: string) {
    this.filterTerm = value;
    this.termChanged.emit(value);
    this.onUpdate();
  }

  @Input() filterFunction: (term) => (value : any) => boolean = t => filterByTerm(t);

  @Input() set data(value: any[] | Observable<any[]>) {
    if (lodash.isArray(value)) {
      this.input = value;
      this.onUpdate();
    } else if (!!value) {
      this.searching = true;
      value.subscribe(r => {
        this.input = r;
        this.searching = false;
        this.onUpdate();
      }, e => this.searching = false);
    }
  }

  @Input() placeholder = "";

  @Output() updated = new EventEmitter<any[]>();

  @Output() termChanged = new EventEmitter<string>();

  searching: boolean;
  private input: any[] = [];

  private onUpdate() {
    setTimeout(() => this.updated.emit(this.input.filter(this.filterFunction(this.filterTerm))), 0);
  }
}
